import React from 'react'

import { AlertDialogBody, AlertDialogFooter } from '@chakra-ui/react'

import { BasicAlertDialog, Button } from '@/components/ui'

interface ResetThresholdConfirmationModalIProps {
  isLoading: boolean
  isOpen: boolean
  onClose: () => void
  onConfirm: () => void
}

export const ResetThresholdConfirmationModal = ({
  isLoading,
  isOpen,
  onClose,
  onConfirm,
}: ResetThresholdConfirmationModalIProps) => {
  return (
    <BasicAlertDialog
      dataTestId='thresholdConfig_resetConfirmDialog'
      isCentered
      isOpen={isOpen}
      onClose={onClose}
      title='Reset to Defaults'
    >
      <AlertDialogBody letterSpacing='-0.53px' py='24px'>
        Are you sure you want to reset threshold values to application defaults?
        Your custom configuration will be removed.
      </AlertDialogBody>
      <AlertDialogFooter>
        <Button
          data-testid='thresholdConfig_resetConfirmDialog_cancel'
          mr='3'
          onClick={onClose}
          variant='secondary'
        >
          Cancel
        </Button>
        <Button
          data-testid='thresholdConfig_resetConfirmDialog_confirm'
          isLoading={isLoading}
          onClick={onConfirm}
          variant='danger'
        >
          Reset to Defaults
        </Button>
      </AlertDialogFooter>
    </BasicAlertDialog>
  )
}
